<form (ngSubmit)="updateInternship()" #internshipForm="ngForm">
  <div class="bottom">

     <div class="header">
      <div class="title">
          <h1>{{ 'internship-dialog.view-title' | translate }}</h1>
      </div>

      <div class="close">
        <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
      </div>
    </div>
    
    <div class="">
      <mat-accordion class="example-headers-align">

      <!-- Dati tirocinio -->
      <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
        <mat-panel-title><mat-icon>work</mat-icon> {{ 'internship-dialog.sections.internship-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.internship-title' | translate }}</label>
            <input *ngIf="!isEditable" type="text" name="internshipTitleView" [value]="internshipData.availableInternshipTitle" disabled placeholder="{{ 'internship-dialog.placeholders.internship-title' | translate }}">
            <select *ngIf="isEditable" [(ngModel)]="internshipData.availableInternshipId" 
                    [ngModelOptions]="{standalone: true}" 
                    (change)="onInternshipSelected($event)"
                    [class.isEditable]="isEditable">
              <option value="" disabled selected>{{ 'internship-dialog.select-available' | translate }}</option>
              <option *ngFor="let internship of availableInternships" [value]="internship.id">
                {{ internship.title }}
              </option>
            </select>
          </div>

          <div class="content-information">
            <label>{{ 'internships.table.position' | translate }}</label>
            <input type="text" name="position" [(ngModel)]="internshipData.availableInternshipPosition"  disabled  placeholder="{{ 'internship-dialog.placeholders.position' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.department' | translate }}</label>
            <input type="text" name="department" [(ngModel)]="internshipData.availableInternshipDepartment"  disabled placeholder="{{ 'internship-dialog.placeholders.department' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.country' | translate }}</label>
            <input type="text" name="country" [value]="internshipData.availableInternshipCountry?.name || ''"  disabled placeholder="{{ 'internship-dialog.placeholders.country' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.city' | translate }}</label>
            <input type="text" name="city" [value]="internshipData.availableInternshipCity?.name || ''"  disabled placeholder="{{ 'internship-dialog.placeholders.city' | translate }}">
          </div>
        </div>

        <div>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Periodo e durata del tirocinio -->
      <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>date_range</mat-icon> {{ 'internship-dialog.sections.period-duration' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.start-date' | translate }}</label>
            <input type="date" name="startDate" [(ngModel)]="internshipData.startDate"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.start-date' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.end-date' | translate }}</label>
            <input type="date" name="endDate" [(ngModel)]="internshipData.endDate"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.end-date' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internships.status.label' | translate }}</label>
            <select [(ngModel)]="internshipData.status" name="status" [disabled]="!isEditable" [class.isEditable]="isEditable" >
            <option value="" disabled selected>{{ 'internship-dialog.select-status' | translate }}</option>
            <option value="Planned">{{ 'common.status.planned' | translate }}</option>
            <option value="Ongoing">{{ 'common.status.ongoing' | translate }}</option>
            <option value="Completed">{{ 'common.status.completed' | translate }}</option>
            </select>
          </div>
        </div>
        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Dati del tirocinante -->
      <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>account_circle</mat-icon> {{ 'internship-dialog.sections.trainee-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="name" [(ngModel)]="internshipData.traineeName"  [disabled]="!isEditable" [class.isEditable]="isEditable"  [class.isEditable]="isEditable" placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="lastname" [(ngModel)]="internshipData.traineeLastname"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="email" [(ngModel)]="internshipData.traineeEmail"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.email' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.phone' | translate }}</label>
            <input type="text" name="phone" [(ngModel)]="internshipData.traineePhone"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.phone' | translate }}">
          </div>
        </div>
        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Dati del tutor -->
      <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>supervisor_account</mat-icon> {{ 'internship-dialog.sections.supervisor-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="content">
           <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="supervisorFirstname" [(ngModel)]="internshipData.supervisorFirstname"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="supervisorLastname" [(ngModel)]="internshipData.supervisorLastname"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="supervisorEmail" [(ngModel)]="internshipData.supervisorEmail"  [disabled]="!isEditable" [class.isEditable]="isEditable"  placeholder="{{ 'internship-dialog.placeholders.email' | translate }}">
          </div>
        </div>

        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
        </div>
      </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>

    <div class="pulsanti">
        <button type="button" class="cancelButton" (click)="toggleCancel()" *ngIf="isEditable">
        <mat-icon>close</mat-icon>{{ 'common.cancel' | translate }}
        </button>

        <button class="saveButton"  *ngIf="isEditable">
        <mat-icon>save</mat-icon>{{ 'common.save' | translate }}
        </button>

        <button type="button" class="editButton" (click)="enableEdit()" *ngIf="!isEditable && canEdit">
        <mat-icon>edit</mat-icon>{{ 'internship-dialog.edit' | translate }}
        </button>

        <div *ngIf="!canEdit && !isEditable" class="info-message">
          <mat-icon>info</mat-icon>
          <span>{{ 'internship-dialog.locked-message' | translate }}</span>
        </div>
    </div>

</form>
